import {
  currentUserIsCompanyOwner,
  isContentManager,
  isDocumentManager,
  isLearningRequestManager,
  isRoot
} from "@/plugins/roles";
import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";

interface IInstruction {
  id: number;
  title?: string;
  titleEn?: string;
  content: any;
  access?: boolean;
  _title?: string;
}

class Instruction {
  id: number;
  title?: string;
  titleEn?: string;
  content: any;
  access?: boolean;
  isContentLoading?: boolean = false;
  path!: string;

  constructor(id: number) {
    const find = instructions.find(el => el.id === id);
    this.id = find!.id;
    this.title = find?.title;
    this.titleEn = find?.titleEn;
    this.path = find!.path!;
    this.access = find?.access;
    this.content = this.getContent(id);
  }

  // ПОЛУЧАЕМ КОНТЕНТ ТЕКУЩЕИ ИНСТРУКЦИИ ПО ID
  getContent(id: number) {
    return this._access
      ? this.getContentByUrl(this.path)
      : `<h2>У вас нет доступа</h2>`;
  }

  get _access() {
    return this.access;
  }

  async getContentByUrl(path: string) {
    try {
      this.isContentLoading = true;
      const r = await fetch(path);
      this.content = await r.text();

      if (
        this.content?.includes("<!-- built files will be auto injected -->")
      ) {
        this.content = "Нет инструкции";
      }

      return this.content;
    } finally {
      this.isContentLoading = false;
    }
  }
}

let instructions = [
  {
    id: 1,
    title: "Закрыть доступ к материалам обучающего",
    titleEn: "Close access to training materials",
    access:
      isRoot() ||
      currentUserIsCompanyOwner() ||
      isLearningRequestManager() ||
      isDocumentManager() ||
      isContentManager(),
    _title: i18n.tc(LocalesFields.CloseAccessToTrainingMaterials),
    path: "/test.html"
  },
  {
    id: 1.1,
    title: "Как сделать пользователя сотрудником компании",
    titleEn: "How to make a user an employee of a company"
  },
  {
    id: 1.2,
    title: "Как выдать роль сотруднику компании",
    titleEn: "How to assign a role to a company employee"
  },
  {
    id: 1.3,
    title: "Смена и восстановление пароля",
    titleEn: "Password change and recovery"
  },
  {
    id: 1.4,
    title: "Приглашение пользователей (инвайты)",
    titleEn: "User invitation (invites)"
  },
  {
    id: 1.5,
    title: "Деактивация пользователя",
    titleEn: "User deactivation"
  },
  {
    id: 1.6,
    title: "Студенты",
    titleEn: "Students"
  },
  {
    id: 2,
    title: "Как добавить лекцию",
    titleEn: "How to add a lecture"
  },
  {
    id: 2.2,
    title: "Как добавить тест",
    titleEn: "How to add a test"
  },
  {
    id: 2.3,
    title: "Как скопировать вопросы из одного теста в другой",
    titleEn: "How to copy questions from one test to another"
  },
  {
    id: 2.4,
    title: "Как прикрепить тест к курсу",
    titleEn: "How to attach a test to a course"
  },
  {
    id: 2.4,
    title: "Тренировочное тестирование",
    titleEn: "Practice testing"
  },
  {
    id: 2.6,
    title: "Комментарии к вопросам теста",
    titleEn: "Comments on test questions"
  },
  {
    id: 2.7,
    title: "Как добавить практическое задание",
    titleEn: "How to add a practice task"
  },
  {
    id: 2.8,
    title: "SCORM курсы",
    titleEn: "SCORM courses"
  },
  {
    id: 2.9,
    title: "Как добавить новый курс",
    titleEn: "How to add a new course"
  },
  {
    id: 3,
    title: "Как добавить запись",
    titleEn: "How to add an entry"
  },
  {
    id: 4,
    title: "Как добавить вебинар",
    titleEn: "How to add a webinar"
  },
  {
    id: 4.1,
    title: "Как получить запись вебинара",
    titleEn: "How to get a webinar recording"
  },
  {
    id: 5,
    title: "Как добавить заявку",
    titleEn: "How to add an application"
  },
  {
    id: 6,
    title: "Как создать договор",
    titleEn: "How to create a contract"
  },
  {
    id: 6.1,
    title: "Как создать счет",
    titleEn: "How to create an bill"
  },
  {
    id: 6.2,
    title: "Как добавить приложение к договору",
    titleEn: "How to add an annex to a contract",
    access:
      isRoot() ||
      currentUserIsCompanyOwner() ||
      isLearningRequestManager() ||
      isDocumentManager() ||
      isContentManager()
  }
];

export { Instruction, instructions, IInstruction };
